import { useState } from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer } from 'recharts'
import stringHelpers from '../../../utilities/stringHelpers'
import { AnalyticsSlider } from '../../shared/analyticsSlider'
import { vehicleAnalyticsChartColours } from '../../../utilities/constants'

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null
    const { name, value } = payload[0].payload
    return (
        <div className="analytics-tooltip">
            <div className="analytics-tooltip-header">
                <span className="analytics-tooltip-dot" style={ { background: payload[0].fill } } />
                <span className="analytics-tooltip-name">{ name }</span>
            </div>
            <span className="analytics-tooltip-value">{ stringHelpers.formatDecimal(value, 0) } vehicle{ value !== 1 ? "s" : "" }</span>
        </div>
    )
}

export const MakeBarChart = ({ breakdown }) => {
    const sorted = Object.entries(breakdown)
        .map(([name, value]) => ({ name, value }))
        .sort((a, b) => b.value - a.value)

    const max = Math.max(10, sorted.length)
    const [limit, setLimit] = useState(Math.min(10, max))

    const data = sorted.length > limit
        ? [...sorted.slice(0, limit), { name: "OTHER", value: sorted.slice(limit).reduce((s, d) => s + d.value, 0) }]
        : sorted

    const chartHeight = Math.max(data.length * 32, 160)

    return (
        <div className="analytics-chart-card">
            <div className="analytics-chart-card-header mb-3">
                <p className="analytics-chart-title">Make</p>
                <AnalyticsSlider label={ `Top ${limit}` } value={ limit } min={ 2 } max={ max } step={ 1 } onChange={ setLimit } />
            </div>
            <ResponsiveContainer width="100%" height={ chartHeight }>
                <BarChart data={ data } layout="vertical" margin={ { top: 0, right: 24, bottom: 0, left: 8 } }>
                    <XAxis type="number" tick={ { fontSize: 11, fill: "#a0aec0" } } axisLine={ false } tickLine={ false } allowDecimals={ false } />
                    <YAxis type="category" dataKey="name" width={ 140 } tick={ { fontSize: 11, fill: "#4a5568" } } axisLine={ false } tickLine={ false } interval={ 0 } />
                    <Tooltip content={ <CustomTooltip /> } cursor={ { fill: "#f7fafc" } } />
                    <Bar dataKey="value" radius={ [0, 6, 6, 0] } maxBarSize={ 16 }>
                        { data.map((entry, index) => (
                            <Cell key={ entry.name } fill={ vehicleAnalyticsChartColours[index % vehicleAnalyticsChartColours.length] } />
                        )) }
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}
